import React from "react";
import { Box, Container, Typography, Grid, Button } from "@mui/material";

export default function Careers() {
  return (
    <>
     <head>
        <title>Careers at Arocoiris Technology</title>
        <meta
          name="description"
          content="Explore open positions at Arocoiris Technology and join our growing team."
        />
         <meta property="og:title" content="Careers at Arocoiris Technology" />
        <meta property="og:description" content="Join Arocoiris Technology and help build intelligent digital products." />
         <meta property="og:url" content="https://www.arocoiristechnology.com/careers" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.arocoiristechnology.com/og-careers.png" />
        <meta name="twitter:image" content="https://www.arocoiristechnology.com/og-careers.png" />
        <script type="application/ld+json">
{`
{
  "@context": "https://schema.org/",
  "@type": "JobPosting",
  "title": "SDET",
  "description": "Join Arocoiris Technology as a Software Development Engineer in Test.",
  "employmentType": "Hybrid",
  "hiringOrganization": {
    "@type": "Organization",
    "name": "Arocoiris Technology",
    "sameAs": "https://www.arocoiristechnology.com/"
  },
  "jobLocationType": "TELECOMMUTE"
}
`}
</script>
      </head>
    <Box sx={{ py: 10, backgroundColor: "#0A192F", color: "white" }}>
       

      <Container maxWidth="lg">

        {/* HERO */}
        <Typography variant="h3" fontWeight={700} sx={{ mb: 2 }}>
          Build the Future With Us
        </Typography>
        <Typography variant="h6" sx={{ color: "#B0BEC5", maxWidth: 700, mb: 6 }}>
          Arocoiris Technology is a lean startup‑studio. We hire builders, thinkers, and problem‑solvers who love shipping fast.
        </Typography>

        {/* OPEN ROLES */}
        <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
          Open Positions
        </Typography>

        <Grid container spacing={4}>
          {[
            { role: "Full‑Stack Engineer", type: "Hybrid" },
            { role: "Product Designer", type: "Hybrid" },
            { role: "AI/ML Engineer", type: "Hybrid" },
            { role: "SDET", subtitle: "Software Development Engineer in Test", type: "Hybrid" }
          ].map((job, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Box
                sx={{
                  p: 3,
                  height: "100%",
                  borderRadius: 3,
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
              >
                <Box>
                  <Typography variant="h6" fontWeight={600}>
                    {job.role}
                  </Typography>
                  {job.subtitle && (
                    <Typography variant="body2" sx={{ color: "#B0BEC5", mt: 0.5 }}>
                      {job.subtitle}
                    </Typography>
                  )}
                  <Typography variant="body2" sx={{ color: "#B0BEC5", mt: 1 }}>
                    {job.type}
                  </Typography>
                </Box>

                <Button
                 variant="outlined"
                    color="success"
                     sx={{ mt: 3 }}
                    component="a"
                    // href={`/apply/${encodeURIComponent(job.role)}`}
                        >
                      Apply Now
                </Button>

              </Box>
            </Grid>
          ))}
        </Grid>
   <Typography variant="body2" sx={{ mt: 2, color: "#B0BEC5" }}>
  Interested in this role? Share your resume at{" "}
  <span style={{ color: "#4CAF50", fontWeight: 600 }}>
    ektamishra@arocoiristechnology.com
  </span>.
</Typography>
      </Container>
    </Box>
    </>
  );
}